export function updateMrcSelect( regionId, mrcField, municipalityField ) {

	let loading = mrcField.nextElementSibling;

	let formData = new FormData();

	formData.append( 'action', 'ilcq_load_mrcs' );
	formData.append( 'region_id', regionId );

	loading.classList.toggle('hidden');

	fetch( nubeeGlobals.ajaxUrl, {
		method: 'POST',
		credentials: 'same-origin',
		body: formData,
	})
	.then( function( response ) {
		// The API call was successful!
		return response.text();
	}).then( function( html ) {

		if( html ) {

			mrcField.innerHTML = '<option value="">' + nubeeGlobals.i18n.ilcq.empty_select.mrc + "</option>\n" + html;
			mrcField.disabled = false;

			municipalityField.innerHTML = '<option value="">' + nubeeGlobals.i18n.ilcq.empty_select.municipality + "</option>\n";
			municipalityField.disabled = true;

			loading.classList.toggle('hidden');

		} else {
			mrcField.disabled = true;
			municipalityField.disabled = true;
			loading.classList.toggle('hidden');
		}

	});

}

export function updateMunicipalitiesSelect( mrcId, municipalityField ) {

	let loading = municipalityField.nextElementSibling;

	let formData = new FormData();

	formData.append( 'action', 'ilcq_load_municipalities' );
	formData.append( 'mrc_id', mrcId );

	loading.classList.toggle('hidden');

	fetch( nubeeGlobals.ajaxUrl, {
		method: 'POST',
		credentials: 'same-origin',
		body: formData,
	})
	.then( function( response ) {
		// The API call was successful!
		return response.text();
	}).then( function( html ) {

		if( html ) {

			municipalityField.innerHTML = '<option value="">' + nubeeGlobals.i18n.ilcq.empty_select.municipality + "</option>\n" + html;
			municipalityField.disabled = false;

			loading.classList.toggle('hidden');

		} else {
			municipalityField.disabled = true;
			loading.classList.toggle('hidden');
		}

	});

}

export function updateAnchorHref( anchor, params ) {
	// Parse the current URL
	const url = new URL(anchor.href);

	// Add or update query string parameters
	Object.keys(params).forEach(key => {
		url.searchParams.set(key, params[key]);
	});

	// Update the anchor's href
	anchor.href = url.toString();
}